import { Routes } from '@angular/router';
import { AuthComponent } from '@auth/auth.component';
import { SelectKeycloakRealmComponent } from '@auth/components/select-keycloak-realm/select-keycloak-realm.component';
import { SelectWorkingPeriodComponent } from '@auth/components/select-working-period/select-working-period.component';
import { KeycloakGuard } from '@auth/keycloak.guard';

export const routes: Routes = [
  {
    path: 'auth',
    component: AuthComponent,
    children: [
      { path: '', redirectTo: 'select-keycloak-realm', pathMatch: 'full' },
      { path: 'login', redirectTo: 'select-keycloak-realm', pathMatch: 'full' },
      { path: 'select-keycloak-realm', component: SelectKeycloakRealmComponent },
      { path: 'select-company', component: SelectWorkingPeriodComponent },
    ],
  },
  {
    path: '',
    canActivate: [KeycloakGuard],
    loadChildren: () => import('./layout/layout.routes').then((m) => m.routes),
  },
  {
    path: '**',
    redirectTo: '/',
  },
];
